import React from 'react'
import { useCart } from '../context/Cart';
import Shop from "../components/CategoryPageProducts";
const Shop2 = () => {
  return (
    <Shop/>
  )
}

export default Shop2